import { helpers } from '@vuelidate/validators'


export default (regex, message) => helpers.withParams({ type: 'regex', regex, message: message || 'Matches pattern (' + regex.toString() + ')' }, v => regex.test(v))
